/* ==========================================================================
   Ateliers — Scroll animations (IntersectionObserver)
   ========================================================================== */

(function() {
  var SELECTORS = '.fade-in, .fade-in-left, .fade-in-right';
  var STEP_SELECTOR = '.visites-step';

  function showAll(container) {
    var root = container || document;
    root.querySelectorAll(SELECTORS).forEach(function(el) {
      el.classList.add('visible');
    });
    root.querySelectorAll(STEP_SELECTOR).forEach(function(el) {
      el.classList.add('visible');
    });
  }

  // Mode éditeur Shopify : tout afficher immédiatement, pas d'animation
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('DOMContentLoaded', function() {
      showAll();
    });

    // Re-render quand une section est chargée/modifiée dans l'éditeur
    document.addEventListener('shopify:section:load', function(e) {
      showAll(e.target);
    });

    return;
  }

  // Mode front : animations au scroll
  if (window.__atelierObserverInit) return;
  window.__atelierObserverInit = true;

  document.addEventListener('DOMContentLoaded', function() {
    var elements = document.querySelectorAll(SELECTORS);
    if (!elements.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(function(el) {
      observer.observe(el);
    });

    // Staggered animation for steps
    var steps = document.querySelectorAll(STEP_SELECTOR);
    if (steps.length) {
      var stepObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var index = Array.from(steps).indexOf(entry.target);
            setTimeout(function() {
              entry.target.classList.add('visible');
            }, index * 200);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -30px 0px'
      });

      steps.forEach(function(step) {
        stepObserver.observe(step);
      });
    }
  });
})();
